import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import EventsListView from "./events-list.html";
import EventsMenuView from "./events-menu.html";
import EventsEditView from "./events-edit.html";
import GuestsListView from "./guests/guests-list.html";
import GuestsImportView from "./guests/import/guests-import.html";
import WorkTeamListView from "./work_team/work_team-list.html";
import TasksListView from "./tasks/tasks-list.html";
import StaffListView from "./staff/staff-list.html";
import ProgramsActsListView from "./programs_acts/programs_acts-list.html";
import MaterialsListView from "./materials/materials-list.html";
import ParkingsListView from "./parkings/parkings-list.html";
import IndicatorsTypesListView from "./indicators_types/indicators_types-list.html";
import DiaryView from "./diary/diary.html";
import BudgetListView from "./budget/budget-list.html";
import SpacesListView from "./spaces/spaces-list.html";
import ResumeListView from "./resume/resume-list.html";
import MailAccountsListView from "./mail_accounts/mail_accounts-list.html";
import InformationsListView from "../informations/informations-list.html";
import InformationsEditView from "../informations/informations-edit.html";
import InscriptionsFormsListView from "../inscriptions_forms/inscriptions_forms-list.html";
import InscriptionsFormsShowInscriptionsView from "../inscriptions_forms/inscriptions_forms-show_inscriptions.html";
import InscriptionsFormsEditView from "../inscriptions_forms/inscriptions_forms-edit.html";
import DocumentsListView from "./documents/documents-list.html";
import DocumentsEditView from "./documents/documents-edit.html";
import AccreditationsListView from "./accreditations/accreditations-list.html";
import HistoricMailsListView from "./historic_mails/historic_mails-list.html";
import NotificationsListView from "../notifications/notifications-list.html";
import NotificationsEditView from "../notifications/notifications-edit.html";
import MailingsListView from "../mailings/mailings-list.html";
import GroupsListView from "./groups/groups-list.html";
import LocationsEventsListView from "./locations/locationsEvents-list.html";
import CmsCategoriesEventListView from "./cms_categories/cms_categories_event-list.html";
import CmsCategoriesEventEditView from "./cms_categories/cms_categories_event-edit.html";
import CmsArticleEventEditView from "./cms_categories/cms_categories_event-edit.html";
import CmsArticleEventListView from "./cms_categories/cms_categories_event-list.html";
import PushNotificationsEventListView from "./push_notifications/push_notifications_event-list.html";
import PushNotificationsEventEditView from "./push_notifications/push_notifications_event-edit.html";
import FoldersListView from "../folders/folders-list.html";

angular.module("events", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
         .state('events', {
                url: "/events",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView
            })
        .state('events.list', {
            url: "/list/:is_template",
            controller: "EventsListCtrl",
            template: EventsListView,
            cache: false,
            onEnter: ['$rootScope', function ($rootScope) {
                $rootScope.is_template = false;
            }]
        })
        .state('menu', {
            url: "/:id/:is_template",
            abstract: true,
            cache: false,
            controller: "EventsMenuCtrl",
            template: EventsMenuView,
            parent: 'events',
            resolve: {
                event: ['Restangular', '$stateParams', function (Restangular, $stateParams) {
                    if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                        return Restangular.one('Events', $stateParams.id).get();
                    }
                    return {};
                }]
            }
        })
        .state('events.edit', {
            url: "/:menu_item_id",
            controller: "EventsEditCtrl",
            template: EventsEditView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_READ"]
        })
        .state('events.edit.guests', {
            url: "/guests/:status/:menu_item_id",
            controller: "EventsGuestsListCtrl",
            template: GuestsListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_GUESTS_READ"]
        })
        .state('events.edit.guests.list', {
            url: "/guests/list",
            template: '<event-guests-page />',
            controller: ['$filter', '$rootScope', function($filter: any, $rootScope: any) {
                $rootScope.title = $filter('translate')('events.title') + " - " + $filter('translate')('events.guests.guests');
                $rootScope.breadcrumb = [
                    {title: $filter('translate')('events.title'), url: "events.list"},
                    {title: $filter('translate')('events.guests.guests')}
                ];
            }],
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_GUESTS_READ"]
        })
        .state('events.edit.guests.import', {
            url: "/guests/import",
            controller: "EventsGuestsImportCtrl",
            template: GuestsImportView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_GUESTS_READ"],
            params: {
                people: null,
                menu_item_id: null
            }
        })
        .state('events.edit.work_team', {
            url: "/work_team/:menu_item_id",
            controller: "EventsWorkTeamListCtrl",
            template: WorkTeamListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_WORK_TEAM_READ"]
        })
        .state('events.edit.tasks', {
            url: "/tasks/:taskId/:menu_item_id",
            controller: "EventsTasksListCtrl",
            template: TasksListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_TASKS_READ"]
        })
        .state('events.edit.staff', {
            url: "/staff/:staffId/:menu_item_id",
            controller: "EventsStaffListCtrl",
            template: StaffListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_STAFF_READ"]
        })
        .state('events.edit.programs_acts', {
            url: "/programs_acts/:programActId/:menu_item_id",
            controller: "EventsProgramsActsListCtrl",
            template: ProgramsActsListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_PROGRAM_ACT_READ"]
        })
        .state('events.edit.materials', {
            url: "/materials/:materialId/:menu_item_id",
            controller: "EventsMaterialsListCtrl",
            template: MaterialsListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_MATERIALS_READ"]
        })
        .state('events.edit.parkings', {
            url: "/parkings/:menu_item_id",
            controller: "EventsParkingsListCtrl",
            template: ParkingsListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_PARKINGS_READ"]
        })
        .state('events.edit.indicators_types', {
            url: "/indicators/:menu_item_id",
            controller: "EventsIndicatorsListCtrl",
            template: IndicatorsTypesListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_INDICATOR_READ"]
        })
        .state('events.edit.diary', {
            url: "/diary/:menu_item_id",
            controller: "EventsDiaryCtrl",
            template: DiaryView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_DIARY_READ"]
        })
        .state('events.edit.budget', {
            url: "/budget/:menu_item_id",
            controller: "EventsBudgetListCtrl",
            template: BudgetListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_BUDGET_READ"]
        })

        .state('events.edit.spaces', {
            url: "/spaces/:menu_item_id",
            controller: "EventsSpacesListCtrl",
            template: SpacesListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_SPACE_READ"]
        })

        .state('events.edit.resume', {
            url: "/resume/:menu_item_id",
            controller: "EventsResumeListCtrl",
            template: ResumeListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["RESUME_REPORT_READ"]
        })
        .state('events.edit.accesscontrol', {
            url: "/accesscontrol/:menu_item_id",
            template: '<event-access-control-page />',
            controller: ['$filter', '$rootScope', 'logService', function($filter: any, $rootScope: any, logService: any) {
                $rootScope.title = $filter('translate')('events.resume.monitoring');
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('events.title'), url: "events.list" },
                    { title: $filter('translate')('events.title'), url: "events.list" },
                    { title: $filter('translate')('events.resume.monitoring') }
                ];
            }],
            parent: 'menu',
            cache: false,
            requiredPermission: ["RESUME_REPORT_READ"]
        })
        .state('events.edit.mail_accounts', {
            url: "/mail_accounts/:menu_item_id",
            controller: "EventMailAccountCtrl",
            template: MailAccountsListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_MAIL_ACCOUNT_READ"]
        })

        .state('events.edit.informations', {
            url: "/informations/:menu_item_id",
            controller: "InformationsListCtrl",
            parent: 'menu',
            template: InformationsListView,
            data: { pageTitle: 'Memoria' },
            cache: false,
            requiredPermission: ["INFORMATION_READ"]
        })

        .state('events.edit.informations.edit', {
            url: "/informations/edit/:information_id",
            controller: "InformationsEditCtrl",
            template: InformationsEditView,
            parent: 'menu',
            data: { pageTitle: 'Memoria' },
            cache: false,
            requiredPermission: ["INFORMATION_READ"]
        })

        .state('events.edit.inscriptions_forms', {
            url: "/inscriptions_forms/:menu_item_id",
            controller: "InscriptionsFormsListCtrl",
            parent: 'menu',
            resolve: {
                is_template: function () { return false }
            },
            template: InscriptionsFormsListView,
            cache: false
        })

        .state('events.edit.inscriptions_forms.show_inscriptions', {
            url: "/inscriptions_forms/show_inscriptions/:inscription_form_id",
            cache: false,
            controller: "InscriptionsFormsShowInscriptionsCtrl",
            parent: 'menu',
            template: InscriptionsFormsShowInscriptionsView,
            //requiredPermission: ["INSCRIPTIONS_FORMS_READ"]
        })
        .state('events.edit.inscriptions_forms.edit', {
            url: "/inscriptions_forms/edit/:inscription_form_id",
            controller: "InscriptionsFormsEditCtrl",
            template: InscriptionsFormsEditView,
            parent: 'menu',
            cache: false,
            resolve: {
                is_template: function () { return false }
            }
        })
        .state('events.edit.documents', {
            url: "/documents/:menu_item_id",
            controller: "EventsDocumentsListCtrl",
            template: DocumentsListView,
            parent: 'menu',
            cache: false
        })
        .state('events.edit.documents.edit', {
            url: "/documents/edit/:document_type_id",
            controller: "EventsDocumentsEditCtrl",
            template: DocumentsEditView,
            parent: 'menu',
            cache: false
        })
        .state('events.edit.accreditations', {
            url: "/accreditations/edit/:document_type_id/:menu_item_id",
            controller: "EventsAccreditationsCtrl",
            template: AccreditationsListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_ACCREDITATION_READ"]
        })
        .state('events.edit.historic_mails', {
            url: "/historic_mails/:menu_item_id",
            controller: "EventsHistoricMailsListCtrl",
            template: HistoricMailsListView,
            parent: 'menu',
            cache: false,
            requiredPermission: ["EVENTS_HISTORIC_READ"]
        })
        .state('events.edit.notifications', {
            url: "/notifications/:menu_item_id",
            controller: "NotificationsListCtrl",
            template: NotificationsListView,
            params: {
                mailing_id: null
            },
            resolve: {
                entity_type: [function () { return "events"; }],
            },
            cache: false,
            parent: 'menu',
            data: { pageTitle: 'Notificaciones' },
            requiredPermission: ["NOTIFICATIONS_READ"]
        })
        .state('events.edit.notifications.edit', {
            url: "/notifications/edit/:notificationId",
            controller: "NotificationsEditCtrl",
            template: NotificationsEditView,
            cache: false,
            parent: 'menu',
            data: { pageTitle: 'Notificación' },
            requiredPermission: ["NOTIFICATIONS_READ"]
        })
        .state('events.edit.mailings', {
            url: "/mailings/:menu_item_id",
            controller: "MailingsListCtrl",
            template: MailingsListView,
            resolve: {
                entity_type: [function () { return "events"; }],
            },
            cache: false,
            parent: 'menu',
            data: { pageTitle: 'Comunicaciones' },
            requiredPermission: ["MAILINGS_READ"]
        })
        .state('events.edit.groups', {
            url: "/groups/:menu_item_id",
            controller: "EventGroupsListCtrl",
            parent: 'menu',
            template: GroupsListView,
            data: { pageTitle: 'Grupos' },
            cache: false
        })
        .state('events.edit.location', {
            url: "/locations/:locationId/:menu_item_id",
            controller: "LocationsEventsListCtrl",
            template: LocationsEventsListView,
            parent: 'menu',
            cache: false
        })
        .state('events.edit.cms_categories-list', {
            url: "/cms_categories/:menu_item_id",
            controller: "cmsCategoriesEventsListCtrl",
            template: CmsCategoriesEventListView,
            parent: 'menu',
            cache: false
        })
        .state('events.edit.cms_categories-edit', {
            url: "/cms_categories/edit/:category_id",
            controller: "cmsCategoriesEventsEditCtrl",
            template: CmsCategoriesEventEditView,
            parent: 'menu',
            cache: false
        })
        .state('events.edit.cms_article-edit', {
            url: "/cms_categories/edit/article/:article_id",
            controller: "cmsArticlesEventsEditCtrl",
            template: CmsArticleEventEditView,
            params: {
                'article_id': "",
                'parent_id': "",
                'standalone': false,
            },
            parent: 'menu',
            cache: false
        })
        .state('events.edit.cms_article-list', {
            url: "/cms_categories/article-list/:menu_item_id",
            controller: "cmsArticlesEventsListCtrl",
            template: CmsArticleEventListView,
            parent: 'menu',
            cache: false
            })
        .state('events.edit.push_notifications', {
            url: "/push_notifications/:menu_item_id",
            controller: "pushNotificationsEventListCtrl",
            template: PushNotificationsEventListView,
            parent: "menu",
            cache: false
        })
        .state('events.edit.push_notifications.edit', {
                url: "/edit/:notificationId",
                controller: "pushNotificationsEventEditCtrl",
                template: PushNotificationsEventEditView,
                params: {
                    'notificationId': "",
                 },
                parent: "menu",
                cache: false
         })
        .state('events.edit.folders', {
            url: "/folders/list/:entity_type/:entity_type_id/:is_public",
            controller: "FoldersListCtrl",
            template: FoldersListView,
            cache: false,
            parent: 'menu',
            data: { pageTitle: 'Carpetas' },
            requiredPermission: ["FILES_READ"],
            resolve: {
                entity_type: ['$stateParams', function ($stateParams) {
                    if (angular.isDefined($stateParams.entity_type) && $stateParams.entity_type != "") {
                        return $stateParams.entity_type;
                    }
                    return null;
                }],
                entity_type_id: ['$stateParams', function ($stateParams) {
                    if (angular.isDefined($stateParams.entity_type_id) && $stateParams.entity_type_id != "") {
                        return $stateParams.entity_type_id;
                    }
                    return null;
                }],
                is_public: ['$stateParams', function ($stateParams) {
                    if (angular.isDefined($stateParams.entity_type_id) && $stateParams.entity_type_id != "") {
                        return $stateParams.is_public;
                    }
                    return null;
                }]
            },
        })

    }])
;
